export default "__VITE_ASSET__JIRN8T0t__"